import type { SVGProps } from 'react';
export const Menu = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path d="M28 16q0 .37-.3.63-.28.26-.7.26H5q-.42-.01-.7-.26A.8.8 0 0 1 4 16q0-.37.3-.63.28-.26.7-.26h22q.42.01.7.26.3.27.3.63M5 9.78h22q.42-.01.7-.26.3-.27.3-.63 0-.37-.3-.63A1 1 0 0 0 27 8H5q-.42.01-.7.26-.3.27-.3.63t.3.63q.28.25.7.26m22 12.44H5q-.42.01-.7.26-.3.27-.3.63 0 .37.3.63.28.26.7.26h22q.42-.01.7-.26.3-.27.3-.63t-.3-.63a1 1 0 0 0-.7-.26" />
  </svg>
);
